import { XStack, styled } from 'tamagui';

const Row = styled(XStack, {
  justifyContent: 'space-between',
  alignItems: 'center',
  px: '$3',
  py: '$4',
  borderBottomWidth: 1,
  borderBottomColor: '$border',

  variants: {
    noBorder: {
      true: {
        borderBottomWidth: 0,
      },
    },
  },
});

export default Row;
